export const RX_NAME_SUGGESTIONS = [
  'READING',
  'COMPUTER',
  'PROGRESSIVE',
  'GENERAL',
  'DISTANCE',
  'SEWING',
  'MUSIC',
  'SURGERY',
  'NEEDLEPOINT',
  'PIANO',
  'NIGHT DRIVING',
];

export function rxExpirationDate(
  examDate?: string | Date,
  oneYearExpiration?: boolean
): Date | null {
  if (!examDate) {
    return null;
  }
  const date = examDate instanceof Date ? new Date(examDate) : new Date(examDate);
  if (isNaN(date.getTime())) {
    return null;
  }
  date.setFullYear(date.getFullYear() + (oneYearExpiration ? 1 : 2));
  return date;
}

export function isRxExpired(
  examDate?: string | Date,
  oneYearExpiration?: boolean,
  expirationDate?: string | Date
): boolean {
  if (expirationDate) {
    const expires = expirationDate instanceof Date ? expirationDate : new Date(expirationDate);
    if (!isNaN(expires.getTime())) {
      return expires.getTime() < Date.now();
    }
  }
  const expires = rxExpirationDate(examDate, oneYearExpiration);
  return !!expires && expires.getTime() < Date.now();
}

export function rxStatusLabel(rx: {
  hide?: boolean;
  archived?: boolean;
  examDate?: string | Date;
  oneYearExpiration?: boolean;
  expirationDate?: string | Date;
}): string {
  if (rx?.hide || rx?.archived) {
    return 'HIDDEN';
  }
  if (isRxExpired(rx?.examDate, rx?.oneYearExpiration, rx?.expirationDate)) {
    return 'EXPIRED';
  }
  return 'ACTIVE';
}

export function rxDoctorName(rx: any): string {
  return (
    String(rx?.doctor || '').trim() ||
    String(rx?.eyeExam?.finalRx?.signoffDoctor || '').trim()
  );
}

export function formatRxExamDate(rx: any): string {
  const exam = rx?.examDate ? new Date(rx.examDate) : null;
  if (!exam || isNaN(exam.getTime())) {
    return '';
  }
  return `${exam.getMonth() + 1}/${exam.getDate()}/${String(exam.getFullYear()).slice(-2)}`;
}

export function formatRxUseLabel(rx: any): string {
  const name = String(rx?.type || rx?.typeOther || 'RX').trim() || 'RX';
  const doctor = rxDoctorName(rx);
  const examLabel = formatRxExamDate(rx);
  return [name, doctor ? `Dr. ${doctor}` : '', examLabel].filter(Boolean).join(' — ');
}

export function formatRxSelectorLabel(rx: any): string {
  const name = String(rx?.type || rx?.typeOther || 'RX').trim() || 'RX';
  const examLabel = formatRxExamDate(rx);
  return examLabel ? `${name}-${examLabel}` : name;
}
